import { useQuery } from "react-query";
import { fetchTimeOffHistory } from "@/features/timeOff/services/timeOffService";
const useTimeOffHistory = (absenceId) => {
    const queryKey = ["timeOffHistory", absenceId];
    const { data, error, isLoading, refetch, isFetching } = useQuery(queryKey, () => fetchTimeOffHistory(absenceId), {
        enabled: Boolean(absenceId),
        staleTime: 60_000,
    });
    return {
        history: data ?? [],
        error: error ? error.message : null,
        isLoading: isLoading || isFetching,
        refetch,
    };
};
export default useTimeOffHistory;
